<template>
	<div class="col-xs-12">
		<div class="alert alert-success" v-if="inbehandeling == 'J'">
			Deze polis is in behandeling.
		</div>
		<div class="alert alert-success" v-if="opgeschort == 'J'">
			Deze polis is tijdelijk stopgezet.
		</div>
	</div>
</template>



<script>
export default {
  name: 'inbehandeling',
  props: {
	  inbehandeling: String,
      opgeschort: String
  }
}
</script>




// WEBPACK FOOTER //
// inbehandeling.vue?3ae2aee2